import BookingsCharges from "../BookingsDetails/BookingsCharges";

const Charges = () => {
    return (
        <>
            <BookingsCharges startingPoint="FolderSearch" />
        </>
    )
}

export default Charges;